<template>
    <ul :class="collapsible_classes">
        <li v-if="!routesEmpty()" class="hr-sect">{{main_link_title}}</li>

        <li v-for="route in routesToDo">


            <!--the collapsible trigger-->
            <a v-if="route.hasOwnProperty('children')"
               class="collapsible-header waves-effect arrow-r">
                <i class="fa" :class="route.icon"></i>
                <span class="text-capitalize">{{route.title}}</span>
                {{log('route',route)}}
                <i class="fa fa-angle-down rotate-icon"></i>
            </a>
            <!--the collapsible target-->
            <div v-if="route.hasOwnProperty('children')"
                 class="collapsible-body">
                <ul class="sub-menu">
                    <li v-for="child_route in route.children" class="is_child">
                        <a :href="child_route.route"
                           class=""
                        >
                            <i class="fa" :class="child_route.icon"></i>
                            <span class="text-capitalize">{{child_route.title}}</span>
                        </a>
                    </li>
                </ul>
            </div>
            <div v-else>
                <a :href="route.route"
                   class=""
                >
                    <i class="fa" :class="route.icon"></i>
                    <span class="text-capitalize">{{route.title}}</span>
                </a>
            </div>
        </li>
    </ul>

</template>

<script>
	import {_} from 'underscore';
	import localforage from 'localforage';
	import VueLocalForage from 'vue-localforage';

	window.Vue.use(VueLocalForage);

	/**
	 * Presents client and core navigation. updates via axios and uses local-storage
	 */
	export default {
		name: "side-navigation",
		props: ['content'],
		mounted() {
			// console.log('this.content.current_route', this.content.current_route);
			this.navigation_namespace = this.content.navigation_namespace;
			this.current_route.route = this.content.current_route;
			this.client_connected = this.content.client_connected;
			this.main_link_title = this.content.title;
			// console.log('this', this);
			// set the current storage config
			this.$storageConfig({
				driver: localforage.LOCALSTORAGE,
				name: this.navigation_namespace
			});

			this.createCurrentRoute();
			// this.readNavigation();
			this.requestNavDataHardcoded();
		},
		data() {
			return {
				collapsible_classes: 'collapsible collapsible-accordion',
				activeLink: '',
				cacheResult: true,
				scrollTarget: '',
				storageParams: {
					name: 'navigration_localforage',// This will rename the database from "localforage"
					// This will force localStorage as the storage
					// driver even if another is available. You can
					// use this instead of `setDriver()`.
					driver: ''
				},
				main_link_title: 'Navigation Links',
				navigation_namespace: 'nav_default',
				dev_navigation: false,
				client_connected: true,
				current_route: {
					parent: '',
					route: ''
				},
				urls: {
					navigation_route: '/navigation'
				},
				routes: {},
				routesToDo: {}
			}
		},
		methods: {
			routesEmpty() {
				return _.isEmpty(this.routesToDo);
			},
			split(routeName) {
				// does it have a explicit parent i.e dev:test.index / the parent will be normalized to devtest

				let split = routeName.split(':');
				// console.log('split', split, 'split.length', split.length);

				// no explicit parent defined
				if (split.length <= 0) {
					split = routeName.split('.');
				}
				// has an explicit parent defined
				else if (split.length === 1) {
					// console.log('split', split);
					split = split[0].split('.')
				}

				else {
					split = split[1].split('.')
				}
				return split;
			},
			createCurrentRoute() {
				this.current_route.parent = this.split(this.current_route.route)[0];
			},
			/**
			 * the route has children so it is a parent. is this route the parent of the current page?
			 * @param route
			 * @returns {boolean}
			 */
			isParent(route) {


				// mark as active if it is the parent and the first split is the same as the current pages first split
				// console.log('isParent', route.parent_id <= 0, 'route_name', route.route_data.route_name);

				if (route.parent_id <= 0) {
					let testRoute = route.route_data.route_name.replace(':', '').split('.')[0],
						testParent = this.current_route.route.replace(':', '').split('.')[0];
//					this.log('test', {'testRoute': testRoute, 'testParent': testParent});
					return testRoute === testParent;
				}

				return false;
// console.log('route',route);
			},
			log(marker, item) {
				// console.log(marker, item);
			},
			readNavigation() {
				let _this = this;
				_this.requestNavData();

				// this.$getItem(this.navigation_namespace).then(function (value) {
				//     // request via axios if it is not there
				//     if (value === null) {
				//         _this.requestNavData();
				//         // console.warn('no data');
				//     }
				//     // data not stored so update / insert it
				//     else {
				//         _this.createRoutes(value);
				//     }
				//     // This code runs once the value has been loaded
				//     // from the offline store.
				//     // console.log(value);
				// }).catch(function (err) {
				//     // This code runs if there were any errors
				//     console.log(err);
				// });

			},
			requestNavDataHardcoded() {
				let _this = this;

				axios.post(_this.urls.navigation_route, {
					client_connected: _this.client_connected,
					navigation_namespace: _this.navigation_namespace
				})
					.then(function (response) {
						// console.log('response',response.data);
						if (response.data.success) {
							// console.log('response.data', response.data);
							// console.log('axios', 'response.data.routes',response.data.routes);
							if (_this.cacheResult) {
								_this.$setItem(_this.navigation_namespace, response.data.routes, function () {
									// console.log('settingItem');
									_this.createRoutes(response.data.routes);
								}).catch(function (err) {
									// This code runs if there were any errors
									console.error(err);
								});
							}
							else {
								_this.createRoutes(response.data.routes);
							}

						}
						else {
							console.error('error processing navigation');
						}

					});
			},
			requestNavData() {
				let _this = this;
// console.log('requestNavData', '_this.urls',_this.urls);
				axios.post(_this.urls.navigation_route, {
					client_connected: _this.client_connected
				})
					.then(function (response) {
						// console.log('response',response.data);
						if (response.data.success) {
							// console.log('response.data', response.data);
							// console.log('axios', 'response.data.routes',response.data.routes);
							if (_this.cacheResult) {
								_this.$setItem(_this.navigation_namespace, response.data.routes, function () {
									// console.log('settingItem');
									_this.createRoutes(response.data.routes);
								}).catch(function (err) {
									// This code runs if there were any errors
									console.log(err);
								});
							}
							else {
								_this.createRoutes(response.data.routes);
							}

						}
						else {
							console.log('nope');
						}

					});
			},
			createRoutes(routes) {
				let _this = this;

				_this.routesToDo = routes;
				setTimeout(function(){
					$('.collapsible').collapsible();
                },1000)
				// console.log('_this.routes', _this.routes);
			},
			scrollTo() {
				setTimeout(function () {
					let navHeight = $('#main-navigation').height(),
						calc = $("#" + itemId).offset().top - (navHeight + 50);
					$('html, body').animate({
						scrollTop: calc
					}, 200);
				}, speed);
			}
		}

	}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// resources/assets/js/components/navigation/sideNavigation.vue?579c541c